import { render, staticRenderFns } from "./InserirContato.vue?vue&type=template&id=8a0692e2&"
import script from "./InserirContato.vue?vue&type=script&lang=js&"
export * from "./InserirContato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports